<template>
  <div
    class="hideable"
    :class="[direction, {hide}]"
    :style="{top, bottom, left, right, zIndex, transition: `transform ${transitionMs}ms ease-in-out`}"
  >
    <slot />
  </div>
</template>

<script>
const DIRECTIONS = ['up', 'down', 'right', 'left'];

export default {
  name: 'FixedHideable',
  props: {
    direction: {
      type: String,
      required: true,
      validator(value) {
        return DIRECTIONS.includes(value);
      },
    },
    hide: {
      type: Boolean,
      required: true,
    },
    transitionMs: {
      type: Number,
      default: 300,
    },
    top: {
      type: String,
      default: null,
    },
    bottom: {
      type: String,
      default: null,
    },
    left: {
      type: String,
      default: null,
    },
    right: {
      type: String,
      default: null,
    },
    zIndex: {
      type: Number,
      default: 99,
    },
  },
};
</script>

<style scoped>
.hideable {
  position: fixed;
}

.hideable.hide.left {
  transform: translateX(-100%);
}

.hideable.hide.right {
  transform: translateX(100%);
}

.hideable.hide.up {
  transform: translateY(-100%);
}

.hideable.hide.bottom {
  transform: translateY(100%);
}
</style>
